import qs from "qs";
import { AdministrationGeneralPut } from "../../types/AdministrationGeneral";
import authAxios, { authHeader } from "../data";

const fetchData = async () => {
  const response = await authAxios.get(`/api/AdministrationGeneral`, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (req: AdministrationGeneralPut) => {
  const response = await authAxios.put(
    `/api/AdministrationGeneral/NextContractNumber`,
    null,
    {
      params: req,
      paramsSerializer: (params: any) => qs.stringify(params),
      headers: authHeader(),
    }
  );

  return response.data;
};

const AdministrationGeneralService = {
  fetchData,
  edit,
};

export default AdministrationGeneralService;
